import { createFileRoute } from "@tanstack/react-router";
import { Vendors } from "@/components/Vendors";

function RouteComponent() {
  return <Vendors />;
}

export const Route = createFileRoute("/_authenticated/vendors/")({
  component: RouteComponent,
  staticData: { page: "admin" },
});
